@if (environment !== 'P') {
  <div
    class="environment-indicator absolute top-0 left-[50%] translate-x-[-50%] z-50 bg-red-900 text-white py-1 px-6 rounded-b-lg"
  >
    <span>{{ environment === 'D' || environment === 'T' ? 'Test omgeving' : 'Acceptatie omgeving' }} </span>
  </div>
}

@if (isImpersonating()) {
  <div
    class="impersonation-indicator absolute z-50 bg-orange-600 text-white py-1 px-6 rounded-b-lg"
    [class.top-0]="environment === 'P'"
    [class.top-8]="environment !== 'P'"
    [class.left-[50%]]="true"
    [class.translate-x-[-50%]]="true"
  >
    <span>
      Je bent ingelogd als
      {{ userService.getFormattedName(userService.me) || userService.me?.username || 'Onbekend' }}
    </span>
  </div>
}

<router-outlet></router-outlet>
